const scrollTo = () => {
  const scrollIt = (destination, duration = 200, callback) => {
    const start = window.pageYOffset;
    const startTime =
      'now' in window.performance ? performance.now() : new Date().getTime();

    const documentHeight = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight,
    );
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.getElementsByTagName('body')[0].clientHeight;
    const destinationOffset =
      typeof destination === 'number' ? destination : destination.offsetTop;
    const destinationOffsetToScroll = Math.round(
      documentHeight - destinationOffset < windowHeight
        ? documentHeight - windowHeight
        : destinationOffset,
    );
    let lastOffset = 0;

    if ('requestAnimationFrame' in window === false) {
      window.scroll(0, destinationOffsetToScroll);
      if (callback) {
        callback();
      }
      return;
    }

    function scroll() {
      const now =
        'now' in window.performance ? performance.now() : new Date().getTime();
      const time = Math.min(1, (now - startTime) / duration);
      const timeFunction = time;
      const newOffset = Math.ceil(
        timeFunction * (destinationOffsetToScroll - start) + start,
      );
      window.scroll(0, newOffset);

      if (
        window.pageYOffset === destinationOffsetToScroll ||
        lastOffset === newOffset
      ) {
        if (callback) {
          callback();
        }
        return;
      }
      lastOffset = Math.ceil(
        timeFunction * (destinationOffsetToScroll - start) + start,
      );

      requestAnimationFrame(scroll);
    }

    scroll();
  };

  document.querySelectorAll('a[href^="#"]').forEach(elem => {
    elem.addEventListener('click', e => {
      scrollIt(document.querySelector(elem.getAttribute('href')), 1000);
    });
  });
};

export default scrollTo;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/scroll-to.js